$.fn.gridOverlay = function(options) {
    var styleString =
        '<style>' +
            '.grid-overlay {' +
                'position: fixed;' +
                'z-index: 4000;' +
                'top: 0;' +
                'left: 0;' +
                'width: 100%;' +
                'height: 100%;' +
                'font-size: 12px;' +
                'pointer-events: none;' +
            '}' +
            
            '.grid-overlay .grid-overlay__inner {' +
                'background-color: red;' +
                'opacity: .3;' +
            '}' +
            
            '.grid-overlay [type="checkbox"],' +
            '.grid-overlay label {' +
                'pointer-events: auto;' +
            '}' +
            
            '.grid-overlay .row {' +
                'display: none;' +
            '}' +
            
            '.grid-overlay.js-show .row {' +
                'display: flex;' +
            '}' +
        '</style>';
        
    // Setting defaults
    var settings = $.extend({
        'containerClass': 'container',
        'columnAmount': 12,
        'outerPadding': '',
        'controlsParentSelector': 'body',
        'parent': 'body'
    }, options);
        
    if ( $('body').data('show-grid-overlay') === true ) {
        
        // Slap the styles up into the head
        $(styleString)
            .appendTo('head'); 
        
        // Render parent grid overlay div
        $('<div>')
            .addClass('grid-overlay')
            .appendTo(settings.parent);
            
        // Render grid contaner div
        $('<div>')
            .addClass('grid-overlay__container ' + settings.containerClass + '')
            .css({
                'padding-left': settings.outerPadding,
                'padding-right': settings.outerPadding
            })
            .appendTo('.grid-overlay');
            
        // Render controls
        $('<span>')
            .css({
                'display': 'inline-flex'
            })
            .addClass('grid-overlay__controls')
            .prependTo(settings.controlsParentSelector);
            
        // Render grid checkbox
        $('<input>')
            .addClass('grid-overlay__checkbox')
            .css('margin-right', '10px')
            .attr('id', 'showGridCheckbox')
            .attr('type', 'checkbox')
            .prependTo('.grid-overlay__controls');
            
        // Render grid checkbox label
        $('<label>')
            .addClass('grid-overlay__label')
            .css('margin-bottom', '0')
            .attr('for', 'showGridCheckbox')
            .text('Grid overlay')
            .insertAfter('.grid-overlay__checkbox');
            
        // Render grid row div
        $('<div>')
            .addClass('grid-overlay__row row')
            .prependTo('.grid-overlay__container');
        
        // Render column divs
        for (var i = 0; i < settings.columnAmount; i++) {
            $('<div class="col-1"><div class="grid-overlay__inner"></div></div>')
                .prependTo('.grid-overlay__row');
        }
         
        // Set height on column divs
        setTimeout(function(){            
            $('.grid-overlay__inner').css({
                'height': $(document).height() + 'px',
            });
        }, 1000);
        
        var gridOverlay = $('.grid-overlay');
        
        $('#showGridCheckbox').on('click', function(){
            var $checkbox = $(this);
            
            if ($checkbox.prop('checked') === true) {
                gridOverlay.addClass('js-show');
            } else {
                gridOverlay.removeClass('js-show');
            }
        });
    }
};